import globals from "@/utils/globals";
import { ISubscriber } from "@studyportals/event-aggregation-service-interface";
import { LocalizedContentServiceReadyEvent } from "@studyportals/portal-localized-content";

export default class LocalizedContentPlugin implements ISubscriber<LocalizedContentServiceReadyEvent> {
	public initiate(): void {
		globals.eventAggregationService?.subscribeTo(LocalizedContentServiceReadyEvent.EventType, this, true);
	}

	public notify(event: LocalizedContentServiceReadyEvent): void {
		globals.localizedContentService = event.localizedContentService;
	}
}